import * as React from "react";
import { IQuestionPart } from "../types";

export const QuestionOptions: React.FC<{
  questions: IQuestionPart[];
}> = ({ questions }) => {
  if (questions.length === 0) {
    return null;
  }
  const nonDeletedQuestions = questions.filter(q => !q.deleted);
  if (nonDeletedQuestions.length === 0) {
    return null;
  }
  return (
    <>
      {new Array(nonDeletedQuestions.length - 1).fill(0).map((_, i) => (
        <option key={i} value={i + 2}>
          {i + 2}
        </option>
      ))}
    </>
  );
};
